import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';

import './ParkingGate.scss';

import commonConstant from '../../common/_commonConstant';
import { Loading } from '..';
import { fetchIoTPublishInformation } from '../../actions';
import { Modal, Dropdown, buildingRefNo, buildingID } from '../../helpers';

const parkingGateLocation = [
  { 'label': 'In', 'value': commonConstant.iotPositionIn },
  { 'label': 'Out', 'value': commonConstant.iotPositionOut },
];

class ParkingGate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'loading': false,
      'location': null,
      'position': null,
    };
    this.positionRef = createRef();
    this.locationRef = createRef();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { publishIoTInformation } = this.props;

    if (nextProps.publishIoTInformation && nextProps.publishIoTInformation && nextProps.publishIoTInformation !== publishIoTInformation) {
      this.setState({ 'loading': false });
      return this.props.handleShow();
    }
  }

  handleValue = (key, value) => this.setState({ [key]: value });

  handleOpenGate = () => {
    const { location, position } = this.state;

    if (location && position && location.value && position.value) {
      this.setState({ 'loading': true });

      this.props.dispatch(fetchIoTPublishInformation({
        'iotDeviceType': commonConstant.iotDeviceParkingGate,
        'parkingGate': {
          'buildingID': buildingID(this.props.getBuildingByRefNo),
          'parkingGateLocation': location.value,
          'parkingGatePosition': position.value,
        },
      }, buildingRefNo(this.props.getBuildingByRefNo)));
    }
  }

  render() {
    const { handleShow, modal, iotDevices } = this.props;
    const { loading, position, location } = this.state;

    return (
      <Modal show={modal} handleToggle={handleShow} header="เปิดประตู">
        {loading ? <Loading/> : null}
        <div className="ParkingGate">
          <div className="box">
            <div className="item">
              <div className="title">Location</div>
              <Dropdown
                id="parking-gate-location"
                template="a"
                placeholder="Location"
                value={location && location.value}
                valueShow={location && location.label}
                ref={this.locationRef}
              >
                {
                  parkingGateLocation.map((ele, index) => (
                    <div
                      id={`parking-gate-position-${index}`}
                      key={`parking-gate-position-${index}`}
                      className="item"
                      onClick={() => {
                        this.handleValue('location', {
                          ...ele,
                          'label': ele.label,
                          'value': ele.value,
                        });
                        this.locationRef.current.handleShowItem();
                      }}
                    >
                      {ele.label}
                    </div>
                  ))
                }
              </Dropdown>
            </div>
            <div className="item">
              <div className="title">Position</div>
              <Dropdown
                id="parking-gate-position"
                template="a"
                placeholder="Position"
                readOnly={!location}
                value={position && position.value}
                valueShow={position && position.label}
                ref={this.positionRef}
              >
                {
                  location && iotDevices[location.value].map((ele, index) => (
                    <div
                      id={`parking-gate-position-${index}`}
                      key={`parking-gate-position-${index}`}
                      className="item"
                      onClick={() => {
                        this.handleValue('position', {
                          ...ele,
                          'label': ele.buildingIotDevicePosition,
                          'value': ele.buildingIotDevicePosition,
                        });
                        this.positionRef.current.handleShowItem();
                      }}
                    >
                      {ele.buildingIotDevicePosition}
                    </div>
                  ))
                }
              </Dropdown>
            </div>
          </div>
          <Button
            id="btn-open-gate"
            className="open-gate btn-curve"
            onClick={() => this.handleOpenGate()}
          >
            เปิดประตู
          </Button>
        </div>
      </Modal>
    );
  }
}

ParkingGate.propTypes = {
  'dispatch': PropTypes.func.isRequired,
  'match': PropTypes.shape({
    'params': PropTypes.shape({
      'buildingID': PropTypes.string,
    }),
  }),
  'myForwardedRef': PropTypes.any,
  'modal': PropTypes.bool,
  'handleShow': PropTypes.func,
  'iotDevices': PropTypes.shape({
    'IN': PropTypes.array,
    'OUT': PropTypes.array,
  }),
  'getBuildingByRefNo': PropTypes.shape({}),
  'publishIoTInformation': PropTypes.shape({}),
};

const mapStateToProps = ({ iotDevices, getBuildingByRefNo, publishIoTInformation }) => ({
  'iotDevices': iotDevices.data,
  'getBuildingByRefNo': getBuildingByRefNo.data,
  publishIoTInformation,
});

export default connect(mapStateToProps)(ParkingGate);
